import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Box } from '@material-ui/core';
import style from './renderDaysStyle';

function RenderDays({
	_month,
	calSelection,
	cbDaySelection,
	min,
	max,
	showWkSelection,
	minWk,
	maxWk
}) {
	const [calDays, setCalDays] = useState([]);
	const classes = style();
	const {
		block,
		disabled,
		range,
		daySelected,
		prevDays,
		nextDays,
		today,
		dayBgBorderStart,
		dayBgBorderEnd,
		dayBg,
		dayTransparent,
		dftCursor,
		pointerCursor
	} = classes;
	useEffect(() => {
		printDays(_month);
	}, [_month]);

	const monthL = 'month';
	const weekL = 'week';
	const dayL = 'day';

	function printDays(pMonth) {
		const currMonth = moment().clone().set(monthL, pMonth);
		const startDay = currMonth.clone().startOf(monthL).startOf(weekL);
		const endDay = currMonth.clone().endOf(monthL).endOf(weekL);
		let day = startDay.clone().subtract(1, dayL);

		const blank = [];
		while (day.isBefore(endDay, dayL)) {
			day = day.clone().add(1, dayL);
			blank.push(day);
		}

		setCalDays(blank);
	}

	function addStyles(day, pMonth) {
		const { start, end } = calSelection;
		const noUsrSelection = [start, end].includes(undefined);

		if (showWkSelection) {
			const minWkStartDt = minWk.startOf(weekL);
			const maxWkEndDt = maxWk.endOf(weekL);
			if (
				day.isBefore(minWkStartDt, dayL) ||
				day.isAfter(maxWkEndDt, dayL) ||
				noUsrSelection ||
				day.isBefore(start, dayL) ||
				day.isAfter(end, dayL)
			) {
				return `${block} ${disabled} ${dftCursor}`;
			}
		} else if (day.isBefore(min, dayL) || day.isAfter(max, dayL)) {
			return `${block} ${disabled} ${dftCursor}`;
		}

		if (!noUsrSelection) {
			if (day.isSame(start, dayL) || day.isSame(end, dayL)) {
				return `${block} ${range}`;
			}

			if (day.isSameOrAfter(start, dayL) && day.isSameOrBefore(end, dayL)) {
				return `${block} ${daySelected}`;
			}
		}
		const currMonth = moment().set(monthL, pMonth);
		switch (currMonth) {
			case day.isBefore(currMonth, monthL):
				return `${block} ${prevDays}`;
			case day.isAfter(currMonth, monthL):
				return `${block} ${nextDays}`;
			case day.isSame(moment(), dayL):
				return `${block} ${today}`;
		}
		return block;
	}

	function handleDayClick(d) {
		if (d.isBefore(min, dayL) || d.isAfter(max, dayL)) {
			return;
		}

		if (showWkSelection) {
			return;
		}

		cbDaySelection(d);
	}

	function addBgStyle(day) {
		let defaultCls = dayTransparent;
		const { start, end } = calSelection;
		if (![start, end].includes(undefined)) {
			if (day.isSame(start, dayL)) {
				defaultCls = `${dayBg} ${dayBgBorderStart}`;
			}

			if (day.isSame(end, dayL)) {
				defaultCls = `${dayBg} ${dayBgBorderEnd}`;
			}
		}
		if (showWkSelection) {
			return `${defaultCls} ${dftCursor}`;
		}

		return `${defaultCls} ${pointerCursor}`;
	}

	return calDays.map((d) => {
		return (
			<Box className={addBgStyle(d)} key={crypto.randomUUID()}>
				<Box
					id={`day-${moment(d).date()}`}
					className={addStyles(d, _month)}
					onClick={() => handleDayClick(d)}>
					{d.clone().format('D')}
				</Box>
			</Box>
		);
	});
}

export default RenderDays;
